export type ConsentCategories = {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
};

export const DEFAULT_CONSENT: ConsentCategories = {
  necessary: true,
  analytics: true,
  marketing: false,
};

const STORAGE_KEY = "cookie_consent_v2";

export function loadConsent(): ConsentCategories {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_CONSENT;
    return { ...DEFAULT_CONSENT, ...JSON.parse(raw) };
  } catch {
    return DEFAULT_CONSENT;
  }
}

export function saveConsent(consent: ConsentCategories) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
  document.cookie = `cookie_consent=${encodeURIComponent(
    JSON.stringify(consent)
  )}; Path=/; Max-Age=${60 * 60 * 24 * 365}; SameSite=Lax`;
}
